const Properties = {
    baseUrl:"https://backend.ucarsoysales.com"
}
export default Properties
